export const defaultRoomAvatar = '/assets/images/avatars/default-room.png';
export const defaultSubroomAvatar = '/assets/images/avatars/default-room.png';
export const defaultUserAvatar = '/assets/images/avatars/users/man-1.png';

export const imageSizes = {
  user: ['28', '40', '50', '60', '105', '120', '250', '350', 'full']
};

export const urlRegx =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.+~#?&//=]*)/g;
